import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.kiosk.print');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-portal-kiosk-print',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/portal.kiosk.print/view.scss */
/* src/app/portal.kiosk.print/view.scss: no such file or directory */`],
})
export class PortalKioskPrintComponent implements OnInit {
    public countdown = 30;

    constructor(@Inject( Service    )         public service: Service    ) { }

    public async ngOnInit() {
        await this.service.render();
    }


}

export default PortalKioskPrintComponent;